import { z } from 'zod';

const CloudflareQuestionSchema = z.object({
  name: z.string(),
  type: z.number(),
});

const CloudflareAnswerSchema = z.object({
  name: z.string(),
  type: z.number(),
  TTL: z.number(),
  data: z.string(),
});

export const CloudflareDnsResponseSchema = z.object({
  Status: z.number(),
  TC: z.boolean(),
  RD: z.boolean(),
  RA: z.boolean(),
  AD: z.boolean(),
  CD: z.boolean(),
  Question: z.array(CloudflareQuestionSchema),
  Answer: z.array(CloudflareAnswerSchema).optional(),
});

export type CloudflareDnsResponse = z.infer<typeof CloudflareDnsResponseSchema>;

export type Metric = {
  metricName: string;
  lastSend: string;
};
